import script from "./PageNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./PageNavigation.vue?vue&type=script&setup=true&lang=js"

import "./PageNavigation.vue?vue&type=style&index=0&id=3ad0bb86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ad0bb86"]])

export default __exports__